"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatchesList = void 0;

var _react = _interopRequireDefault(require("react"));

var _Loading = require("../../molecules/Loading");

var _atoms = require("../../atoms");

var _GameSummary = require("../../molecules/GameSummary");

require("./MatchesList.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic
 */
var MatchesList = function MatchesList(props) {
  var loading = props.loading;
  var gameList = props.games;
  var profileKey = props.profileKey ? props.profileKey : '';

  function full_game_url(gameItem) {
    if (gameItem.churned && profileKey && !props.isAnonymousUser) {
      return "".concat(process.env.REACT_APP_GO_TRACEUP, "/traceid/athlete/").concat(profileKey, "/game/").concat(gameItem.game_id, "/item/first/");
    } else {
      return "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat(gameItem.home_team_slug, "/games/").concat(gameItem.game_id, "/touch-chains/first/choose");
    }
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "player-matches"
  }, !loading && gameList && gameList.length >= 1 && gameList.map(function (gameItem) {
    return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
      className: "row",
      key: gameItem.game_id
    }, /*#__PURE__*/_react.default.createElement(_GameSummary.GameSummary, {
      homeTeamStyle: gameItem.home_team_jersey_color,
      homeTeamName: gameItem.home_team_title,
      homeTeamScore: gameItem.home_team_score,
      awayTeamStyle: gameItem.away_team_jersey_color,
      awayTeamName: gameItem.away_team_title,
      awayTeamScore: gameItem.away_team_score,
      showTime: true,
      diffDates: gameItem.full_date ? gameItem.full_date : gameItem.start_time
    }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      marginTop: "3"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "watch-full-match-link",
      "data-trk-act": "Games List",
      target: "_blank",
      rel: "noopener noreferrer",
      href: full_game_url(gameItem),
      key: "moment-item-".concat(gameItem.game_id)
    }, "Watch full game \u2192")));
  }), !loading && gameList.length === 0 && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "no-matches"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, null, "There are no full games"), /*#__PURE__*/_react.default.createElement(_atoms.Label, null, "available right now\u2026")), loading && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "loading"
  }, /*#__PURE__*/_react.default.createElement(_Loading.Loading, null), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true,
    type: _atoms.Label.Type.Heading3,
    marginLeft: "4",
    marginRight: "4",
    content: "Loading games ..."
  })));
};

exports.MatchesList = MatchesList;